import React, { useMemo, useRef, useState } from "react"
import styled from "styled-components"
import { clamp, getCssSizeValue, setCssVars } from "@/utils/utils"
import { ScrollTrigger, useGSAP } from "@/utils/gsap"
import GridContainer from "@/components/common/GridContainer"
import Info from "@/components/ParallaxSlider/Desktop/Info"
import useIsomorphicLayoutEffect from "@/hooks/useIsomorphicLayoutEffect"
import useColor from "@/hooks/useColor"
import SlideImage from "@/components/ParallaxSlider/SlideImage"
import Badge from "@/components/ParallaxSlider/Badge"

const Wrapper = styled.div`
	--local-duration: 1s;
	--bg-color: transparent;
	background-color: var(--bg-color);
	height: ${({ $length }) => `${$length || 1}00svh`};
	transition: background-color var(--local-duration) var(--ease);
	//> .pin-spacer{
	//	//margin: 0 !important;
	//	display: flex !important;
	//	width: 100% !important;
	//}
`

const ImageWrapper = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	height: 100%;

	&.image {
		width: calc(100% + var(--paddingX));
		translate: calc(-1 * var(--paddingX));
	}
`

const Container = styled.div`
	height: 100svh;
	width: 100%;

	.grid-container {
		height: 100%;
		position: relative;
	}
`

const ASSET_VARIANTS = {
	IMAGE: "image",
	ILLUSTRATION: "illustration",
}

const Header = styled.div`
	font-weight: 600;
	--offset: calc(var(--grid-gap) + ${getCssSizeValue(20)});
	position: absolute;
	top: 16%;
	left: 100%;
	width: calc(100% - ${getCssSizeValue(20)});
	margin-left: var(--offset);
	padding-top: ${getCssSizeValue(32)};
	border-top: 1px solid ${({ theme }) => theme.colors.slateGray};
`

const ParallaxSliderDesktop = ({ id = "", header = "", button = {}, slides = [] }) => {
	const WrapperRef = useRef()
	const ContainerRef = useRef()
	const [index, setIndex] = useState(0)
	const currentSlide = useMemo(() => slides[index], [slides, index])
	const bgColor = useColor(currentSlide?.backgroundColor?.color)
	const imageClassName = useMemo(() => (currentSlide?.assetVariant === ASSET_VARIANTS.IMAGE ? "image" : "illustration"), [currentSlide])

	useGSAP(
		() => {
			ScrollTrigger.create({
				trigger: WrapperRef.current,
				pin: ContainerRef.current,
				end: "bottom bottom",
				// markers: true,
				pinSpacing: false,
				invalidateOnRefresh: true,
				onUpdate: ({ progress }) => {
					//sets the index of the current slide, returns an int
					const i = clamp(Math.floor(progress * slides.length), 0, slides.length - 1)
					setIndex(i)
				},
			})
		},
		{
			dependencies: [slides],
			revertOnUpdate: true,
			scope: WrapperRef.current,
		},
	)

	useIsomorphicLayoutEffect(() => {
		setCssVars(WrapperRef.current, { "bg-color": bgColor })
	}, [bgColor])

	return (
		<Wrapper id={id} ref={WrapperRef} $length={slides?.length || 1}>
			<Container ref={ContainerRef}>
				<GridContainer>
					<Badge data={button} />
					<ImageWrapper className={`col-mobile-8 ${imageClassName}`}>
						<Header className="typo-borna typo-borna-66">{header}</Header>
						<SlideImage data={currentSlide} className={imageClassName} />
					</ImageWrapper>
					<Info slides={slides} current={currentSlide} index={index} className="col-mobile-8 col-desktop-8" />
				</GridContainer>
			</Container>
		</Wrapper>
	)
}

export default ParallaxSliderDesktop
